import React from "react";
import "./faq.css";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

function Faq() {
  return (
    <div className="faq">
      <div className="shop_header">
        <div
          className="container"
          style={{ fontSize: "20px", fontFamily: "-moz-initial" }}
        >
          <b>F.A.Q.</b>
          <br />
          <p style={{ paddingTop: "10px" }}>Home/F.A.Q.</p>
        </div>
      </div>
      <div className="faq_bdy container ">
        <Accordion allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <b className="accordion_head">
                  HOW DO I ORDER A SKIN FOR MY DEVICE?
                </b>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className="accordion_bdy">
                Choose your exact device from the store section. Then select the
                cut type you want & then the coverage & then the texture of your
                skin. You can also customize which texture you want for which
                part of the device. Finally, just place the order. That’s it.
                It’s that easy indeed.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <b className="accordion_head">
                  HOW LONG WILL IT TAKE FOR MY ORDER TO SHIP?
                </b>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className="accordion_bdy">
                Your order will be dispatched within 24-48 hrs of receiving it.
                It may take a bit longer than usual on certain scenarios
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <b className="accordion_head">
                  I LIVE IN A SMALL TOWN IN INDIA, CAN FIVEOTA DELIVER TO ME?
                </b>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className="accordion_bdy">
                Yes, We ship orders all over India.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <b className="accordion_head">CAN I TRACK MY ORDER?</b>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className="accordion_bdy">
                Yes, you will get regular updates & tracking details via mail to
                let you know about the status of your order. Kindly also check
                your Junk/Spam folder as our mail might end up there depending
                on your mailbox setting.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <b className="accordion_head">DO YOU SHIP INTERNATIONALLY?</b>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p className="accordion_bdy">
                We ship orders across the globe! To check if we deliver in your
                country click here.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
}

export default Faq;
